import { Component, Input, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { PickedFile } from '@capawesome/capacitor-file-picker';
import { AuthService } from '../../services/auth.service';
import { Document, User } from 'src/app/models/models';

@Component({
  selector: 'app-document-manager',
  templateUrl: './document-manager.component.html',
  styleUrls: ['./document-manager.component.scss'],
})
export class DocumentManagerComponent implements OnInit {
  @Input() enableLibraryToggle: boolean = false;
  @Input() form: FormGroup;
  user: User;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.user = this.authService.user.value;
  }

  reset() {
    this.form.reset();
  }

  addFile(files: PickedFile[]) {
    const file = files[0];
    this.form.patchValue({
      file: {
        name: file.name,
        data: file.data,
      },
    });
  }

  removeFile() {
    this.form.patchValue({
      file: {
        name: null,
        data: null,
      },
    });
  }
}
